import {CHANGE_ACTIVE_BREAKPOINT} from "./matchMediaActions";

export function activeBreakpoint(state = null, action) {
    switch (action.type) {
        case CHANGE_ACTIVE_BREAKPOINT:
            return action.payload;
        default:
            return state;
    }
}
